import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

export const KTFormSelectSize = {
  default: '',
  large: 'form-control-lg',
  small: 'form-control-sm',
};

KTFormSelect.propTypes = {
  // required
  name: PropTypes.string.isRequired,

  // optional
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  text: PropTypes.string,
  disabled: PropTypes.bool,
  isCustom: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(KTFormSelectSize)),
  multiple: PropTypes.bool,
  rows: PropTypes.number,

  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  enableCheckValid: PropTypes.bool,
  isTouched: PropTypes.bool,
  isValid: PropTypes.bool,
  feedbackText: PropTypes.string,
};

KTFormSelect.defaultProps = {
  options: [],
  value: '',
  text: '',
  disabled: false,
  isCustom: false,
  size: KTFormSelectSize.default,
  multiple: false,
  rows: 1,

  onChange: null,
  onBlur: null,
  onFocus: null,
  enableCheckValid: false,
  isValid: true,
  isTouched: false,
  feedbackText: '',
};

/**
 *
 * @param {{
 * options: {name: string, value: string}[]
 * name: string,
 * value: string|number,
 * text: string,
 * disabled: boolean,
 * isCustom: boolean,
 * size: string,
 * multiple: boolean,
 * rows: number,
 * onChange: function,
 * onBlur: function,
 * onFocus: function,
 * enableCheckValid: boolean,
 * isValid: boolean,
 * isTouched: boolean,
 * feedbackText: string,
 * }} props
 * @returns
 */
function KTFormSelect(props) {
  // MARK: --- Params ---
  const {
    name,

    options,
    value,
    text,
    disabled,
    isCustom,
    size,
    multiple,
    rows,

    onChange,
    onBlur,
    onFocus,
    enableCheckValid,
    isValid,
    isTouched,
    feedbackText,
  } = props;

  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  // MARK: --- Functions ---
  function handleChange(e) {
    const targetValue = e?.target?.value;
    setInputValue(targetValue);
    if (onChange) {
      onChange(targetValue);
    }
  }

  function handleBlur() {
    if (onBlur) {
      onBlur();
    }
  }

  function handleFocus() {
    if (onFocus) {
      onFocus();
    }
  }

  return (
    <div>
      <select
        id={name}
        name={name}
        className={`
                    form-control
                    ${isCustom ? 'custom-select shadow-none' : `form-select ${size}`}
                    ${enableCheckValid && isTouched ? `${isValid ? 'is-valid' : 'is-invalid'}` : ''}
                `}
        // defaultValue={inputValue}
        value={inputValue}
        disabled={disabled}
        multiple={multiple}
        size={multiple ? rows : ''}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
      >
        {options.map((item, index) => {
          return (
            <option key={index} value={item.value}>
              {item.name}
            </option>
          );
        })}
      </select>
      {enableCheckValid && !isValid && isTouched && !_.isEmpty(feedbackText) && (
        <div className="fv-plugins-message-container">
          <div className="fv-help-block">{feedbackText}</div>
        </div>
      )}
      {!_.isEmpty(text) && <span className="form-text text-muted">{text}</span>}
    </div>
  );
}

export default KTFormSelect;
